import { logoutSuccess } from "../store/actions/userActions";
import jsesc from "jsesc";

export function errorManagement(err, options) {
    if (!err) return;

    const { locale, dispatch } = options;

    if (Array.isArray(err.errors)) {
        for (let error of err.errors) {
            switch (error.code) {
                case "GRAPHQL_VALIDATION_FAILED":
                case "GRAPHQL_PARSE_FAILED":
                case "404":
                    return (window.location.href = jsesc(`/${locale || "en"}/not_found`));
                case "401":
                    return dispatch && dispatch(logoutSuccess());
                case "403":
                    return (window.location.href = jsesc(`/${locale || "en"}/unauthorized`));
                default:
                    break;
            }
        }
    }
}
